var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.143 19.286c-.366 0-.731-.14-1.01-.419l-5.714-5.714a1.427 1.427 0 0 1 0-2.02 1.427 1.427 0 0 1 2.02 0l4.704 4.704L19.561 5.42a1.427 1.427 0 0 1 2.02 0 1.427 1.427 0 0 1 0 2.02L10.153 18.867a1.43 1.43 0 0 1-1.01.419"
})));
export default SvgGemCheck;